import React from "react";

const Footer = ({dataFooter}) => {

    return <footer className={`p-8 md:flex md:justify-between`}>
        <div className={`text-center text-xs`}>
            {dataFooter ? dataFooter.map((item, index) => {
                return (
                    <a href={item.link_footer}><span className={`mx-4 ${index === 0 ? 'hidden' : ''}`}>|</span>{item.title_footer}</a>
                )
            }) : ''}
        </div>
        <div className={`text-center my-4 md:m-0`}>
            <p>© 2025 L’Oréal</p>
        </div>
    </footer>
}

export default Footer
